import { LayaGL } from "../../../layagl/LayaGL";
import { Vector2 } from "../../../maths/Vector2";
import { Vector3 } from "../../../maths/Vector3";
import { BaseRenderNode2D } from "../../../NodeRender2D/BaseRenderNode2D";
import { Command2D } from "./Command2D";
export class DrawRenderElement2DCMD extends Command2D {
    static create(element, mat = null) {
        var cmd = DrawRenderElement2DCMD._pool.length > 0 ? DrawRenderElement2DCMD._pool.pop() : new DrawRenderElement2DCMD();
        cmd.renderElement = element;
        cmd._setMatrix(mat);
        return cmd;
    }
    get renderElement() {
        return this._renderElement;
    }
    set renderElement(value) {
        this._renderElement = value;
        this._drawElementCMDData.setRenderelements([this._renderElement]);
    }
    constructor() {
        super();
        this._drawElementCMDData = LayaGL.render2DRenderPassFactory.createDraw2DElementCMDData();
        this._renderSize = new Vector2();
    }
    _setMatrix(value) {
        value ? (this._matreix = value.clone()) : (this._matreix = null);
        if (this._matreix && this.renderElement.nodeCommonMap.indexOf("BaseRender2D") != -1) {
            let vec3 = Vector3.TEMP;
            vec3.x = this._matreix.a;
            vec3.y = this._matreix.c;
            vec3.z = this._matreix.tx;
            this._renderElement.value2DShaderData.setVector3(BaseRenderNode2D.NMATRIX_0, vec3);
            vec3.x = this._matreix.b;
            vec3.y = this._matreix.d;
            vec3.z = this._matreix.ty;
            this._renderElement.value2DShaderData.setVector3(BaseRenderNode2D.NMATRIX_1, vec3);
        }
    }
    run() {
        if (Vector2.equals(this._renderSize, this._commandBuffer._renderSize))
            return;
        this._renderSize.setValue(this._commandBuffer._renderSize.x, this._commandBuffer._renderSize.y);
        this._renderElement.value2DShaderData.setVector2(BaseRenderNode2D.BASERENDERSIZE, this._renderSize);
    }
    recover() {
        super.recover();
        DrawRenderElement2DCMD._pool.push(this);
    }
    getRenderCMD() {
        return this._drawElementCMDData;
    }
    destroy() {
        this._renderElement = null;
        this._drawElementCMDData = null;
    }
}
DrawRenderElement2DCMD._pool = [];
